module.exports = __webpack_public_path__ + "img/chat.b823161d.svg";